const state = {
  // (API): API 호출을 통해 바인딩되는 변수들에 붙이겠습니다.

  token: null, // (API)JWT 토큰
  user: null, // (API)로그인 유저 데이터, 로그인시 로컬스토리지에 저장되고, 로그아웃시 삭제됨

  isAddCampaignItem: false, // true: 추가를 위한 AddCampaignItem으로 컴포넌트 스위칭, false: 기존 뷰로 스위칭
  isEditCampaignItem: false, // true: 편집을 위한 AddCampaignItem으로 컴포넌트 스위칭, false: 기존 뷰로 스위칭
  campaigns: [], // (API)캠페인 리스트
  campaign: {}, // (API)캠페인과 그에 속한 아이템.
  items: [], // (API)캠페인 아이템 리스트
  item: {}, // 캠페인 아이템 추가, 편집시 사용. 캠페인 아이템에 대해 전역변수처럼 사용하였음.
  push: {
    // 캠페인 아이템 추가나 편집 중 타입이 푸시알림인 경우 시간을 저장.
    date: null,
    hour: null,
    minute: null,
  },
  managers: [], // (API) 광고주 리스트
  statistic: {}, // (API) 캠페인 통계치.
  confirm: {
    show: false,
    title: null,
    content: null,
    onConfirm: () => {},
    onClose: () => {},
  },

  schdules: {
    header: [],
    footer: [],
  },
  alerts: [],
};

export default state;
